const app = {
    alerts: {
        _: 'app.alerts',
        dismiss: 'app.alerts.dismiss',
    },
    config: {
        _: 'app.config',

        modelling: {
            _: 'app.config.modelling',
            emissionData: 'app.config.modelling.emission-data',
            runModels: 'app.config.modelling.run-models',
        },

        monitoring: 'app.config.monitoring',
    },
    reports: 'app.reports',
};

const appLegacy = {};

const api = {
    monitor: {
        data: {
            read: 'api.monitoring.data.read',
            write: 'api.monitoring.data.write',
        },
    },
    system: {
        accessControls: {
            read: 'api.system.access-controls.read',
            linkToAccessGroup: 'api.system.access-controls.link-to-access-group',
            linkToAuthDomain: 'api.system.access-controls.link-to-auth-domain',
            linkToCredential: 'api.system.access-controls.link-to-credential',
        },
        accessGroups: {
            read: 'api.system.access-groups.read',
            create: 'api.system.access-groups.create',
            delete: 'api.system.access-groups.delete',
            update: 'api.system.access-groups.update',
        },
        authDomains: {
            read: 'api.system.auth-domains.read',
            create: 'api.system.auth-domains.create',
            delete: 'api.system.auth-domains.delete',
            update: 'api.system.auth-domains.update',
        },
        companies: {
            read: 'api.system.companies.read',
            create: 'api.system.companies.create',
            delete: 'api.system.companies.delete',
        },
        credentials: {
            read: 'api.system.credentials.read',
        },
        diagnosis: 'api.system.diagnostics',
        facilities: {
            create: 'api.system.facilities.create',
            delete: 'api.system.facilities.delete',
        },
        jobs: {
            enqueue: 'api.system.jobs.enqueue',
        },
        reportTypes: {
            read: 'api.system.reportTypes.read',
        },
        units: {
            read: 'api.system.units.read',
        },
        users: {
            read: 'api.system.users.read',
            modify: 'api.system.users.modify',
            delete: 'api.system.users.delete',
        },
        contacts: {
            read: 'api.system.contacts.read',
            create: 'api.system.contacts.create',
            delete: 'api.system.contacts.delete',
            update: 'api.system.contacts.update',
        },
    },
    company: {
        alerts: {
            modify: 'api.company.alerts.modify',
        },
        processes: {
            read: 'api.company.monitors.read',
            modify: 'app.config.monitoring',
            delete: 'api.company.monitor.delete',
        },
        processVariables: {
            read: 'api.company.monitor-variables.read',
            readData: 'api.company.monitor-variable-data.read',
        },
        reportDefinitions: {
            read: 'api.company.report-definitions.read',
            create: 'api.company.report-definitions.create',
            update: 'api.company.report-definitions.update',
            delete: 'api.company.report-definitions.delete',
        },
        sequences: {
            read: 'api.company.sequences.read',
            create: 'api.company.sequences.create',
            modify: 'api.company.sequences.modify',
            delete: 'api.company.sequences.delete',
        },
    },
};

const service = {};

const knownAccessControls = {
    app,
    appLegacy,
    api,
    service,
};

export default knownAccessControls;

/**
 * Collections of disparate access controls for access to various resources
 */
export const RequiredAccessControls = {
    alerts: {
        featureFlag: app.alerts._,
        modifyAlerts: api.company.alerts.modify,
    },
};
